import {mapGetters} from 'vuex'

const screenSize = {
    ...mapGetters(['getScreenSize']),
    install(Vue) {
        Vue.prototype.$dateSize1 =  function() {
            if (this.getScreenSize.width > 1825)
                {return 8}
            else if (this.getScreenSize.width < 1825 && this.getScreenSize.width > 1475)
                {return 10}
            else if (this.getScreenSize.width < 1475 && this.getScreenSize.width > 1200)
                {return 12}
            else
                {return 12}
        }
    }
}
    
export default screenSize